import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { changelogEntries } from './changelog-entries';

@Component({
  selector: 'app-changelog',
  imports: [CommonModule, MatCardModule, TranslateModule],
  templateUrl: './changelog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './changelog.component.css'
})
export class ChangelogComponent {
  entries = changelogEntries;
}
